<script lang="ts">
	import { page } from '$app/state';
	import '$lib/assets/css/post.css';
	import { ChangeWords, PageBase } from '$lib/components';
	import Hero from '$lib/components/hero/Hero.svelte';
	import Reviews from '$lib/components/Review/Reviews.svelte';
	import SocialMeta from '$lib/components/SocialMeta/SocialMeta.svelte';
	import { clearSearchStore } from '$lib/stores/search.svelte.js';
	import { serializeJsonLd } from '$lib/utils/json-ld.js';
	import { text } from '$lib/utils/text';

	// Server data
	const { data } = $props();
	clearSearchStore();
	// Derived data
	const { title, description, content, from, to, distance, durationText, reviews, tripadvisor } =
		$derived(data);

	// Top cities
	const topCities = [
		'Prague',
		'Munich',
		'Vienna',
		'Budapest',
		'Berlin',
		'Salzburg',
		'Bratislava',
		'Krakow',
		'Nuremberg',
		'Dresden',
		'Zurich',
		'Frankfurt',
		'Stuttgart',
		'Innsbruck',
		'Linz',
		'Passau',
		'Regensburg'
	];

	const list = ['Shuttle Shared Car', 'Private Taxi', 'Private Bus'];
</script>

<svelte:head>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html serializeJsonLd(data.jsonLdSchema)}
</svelte:head>

<SocialMeta appName={data.appName} appUrl={data.appUrl} {title} {description} url={page.url.href} />
<PageBase {title} {description}>
	<Hero
		apiKey={data.googleKey}
		searchTitle="Find your car to {to.city}"
		from="{from.city}, {from.country}"
		to="{to.city}, {to.country}"
	>
		<div>
			<h1 class="text-3xl xl:text-5xl font-bold !text-white gradient_text_over_image">
				Travel from {from.city} to {to.city}
			</h1>
			<h2 class="text-xl lg:text-3xl">
				Book a <span class="text-secondary"><ChangeWords {list} /></span>
			</h2>
		</div>
	</Hero>
	<div class="flex flex-col gap-y-8 relative xl:px-5 mx-auto">
		<section>
			<div class="grid grid-cols-1 lg:grid-cols-3 gap-4 pb-10">
				<div>
					<div class="p-8 bg-two rounded-base">
						<table class="city-info w-full">
							<tbody>
								<tr>
									<td class="text-slate-600 dark:text-slate-400">Origin city:</td>
									<td>
										<a href="/taxi/{text.slugify(from.city)}" title="Taxi from {from.city}">
											{from.city}, {from.country}
										</a>
									</td>
								</tr>
								<tr>
									<td class="text-slate-600 dark:text-slate-400">Destination city:</td>
									<td>
										<a href="/taxi/{text.slugify(to.city)}" title="Taxi from {to.city}">
											{to.city}, {to.country}
										</a>
									</td>
								</tr>
								{#if distance > 0}
									<tr>
										<td class="text-slate-600 dark:text-slate-400">Distance in km:</td>
										<td>{distance} km</td>
									</tr>
									<tr>
										<td class="text-slate-600 dark:text-slate-400">Distance in miles:</td>
										<td>{Math.round(distance * 0.621371)} miles</td>
									</tr>
									<tr>
										<td class="text-slate-600 dark:text-slate-400">Travel time:</td>
										<td>{durationText}</td>
									</tr>
								{/if}
								<tr>
									<td class="text-slate-600 dark:text-slate-400">Similar route:</td>
									<td>
										<a
											href="/taxi/{text.slugify(to.city)}/{text.slugify(from.city)}"
											title="Taxi from {to.city} to {from.city}"
										>
											{to.city} to {from.city}
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<div class="top-cities flex flex-wrap">
							{#each topCities as city}
								<a href="/taxi/{text.slugify(city)}">
									<span class="py-1 px-2 bg-one rounded-xl">{city}</span>
								</a>
							{/each}
						</div>
					</div>
				</div>
				<div class="post col-span-1 lg:col-span-2 xl:px-8 p-5 rounded-base">
					<h2 class="flex flex-col gap-y-2">
						<span class="text-secondary text-3xl">{title}</span>
						<span>Shuttle Shared Service, Private Taxi or Bus</span>
					</h2>
					<hr class="my-3 border-two" />
					<div class="whitespace-pre-line">
						<!-- eslint-disable-next-line svelte/no-at-html-tags -->
						{@html content}
					</div>
				</div>
			</div>
		</section>

		<section>
			<Reviews {reviews} {tripadvisor} />
		</section>
	</div>
</PageBase>

<style lang="scss">
	h1 {
		line-height: 1.2;
	}
	.city-info {
		td {
			padding: 10px 0;
		}
		a {
			text-decoration: underline !important;
			text-underline-offset: 4px;
		}
	}
	.top-cities {
		position: relative;
		left: -5px;
		margin-top: 2rem;
		a {
			margin: 0.7rem 0.2rem;
		}
	}
</style>
